import Constants from '@/utils/constants';
import { dayjs } from '@/utils/dateTimeUtils';

import {
	TRANSACTION_LIST_REQUESTING,
	TRANSACTION_LIST_SUCCESS,
	TRANSACTION_LIST_ERROR,
	RESET_TRANSACTIONS,
	SET_OPTIONAL_FIELD,
} from './types';

const today = new Date();
const weekStart = dayjs().startOf('day').toDate();
export const initialState = {
	loading: false,
	entities: [],
	error: undefined,
	currentPage: 1,
	size: Constants.PAGE_SIZE,
	filters: {
		status: ['COMPLETED'],
	},
	to: today.getTime(),
	from: weekStart.getTime(),
	selectedDateType: 'today',
	total: 0,
	totalAmount: 0,
	offset: 0,
	transactionType: 'FORWARD',
	optionalFields: {},
};

function transaction(state = initialState, action) {
	switch (action.type) {
		case TRANSACTION_LIST_REQUESTING:
			return {
				...state,
				filters: action.payload.filters,
				from: action.payload.from,
				to: action.payload.to,
				selectedDateType: action.payload.selectedDateType,
				offset: action.payload.offset,
				loading: true,
				entities: [],
				transactionType: action.payload.transactionType,
				error: undefined,
			};
		case TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				total: action.data.data.totalResults,
				totalAmount: action.data.data.totalAmount,
				entities: action.data.data.results,
				currentPage: action.data.currentPage,
			};
		case TRANSACTION_LIST_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case SET_OPTIONAL_FIELD:
			return {
				...state,
				optionalFields: action.payload.optionalFields,
			};
		case RESET_TRANSACTIONS:
			return initialState;
		default:
			return state;
	}
}

export default transaction;
